<template>
  <div class="px-4 sm:px-6 lg:px-8 bg-gray-800  pt-10">
   


    <form class="space-y-8 divide-y divide-gray-700">
      <div class="space-y-8 divide-y divide-gray-700">
        <div>
          <div class="flex items-center">
            <h1 class="text-3xl font-semibold text-white">New Place</h1>
          </div>

          <div class="flex items-center">

      
              <div class="mt-6 sm:mt-0 w-full sm:w-10/12">
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="dane.title"
                    name="title"
                    id="title"
                    autocomplete="title"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 text-3xl font-semibold text-white bg-gray-800"
                  />
                </div>
              </div>



          </div>

          <div class="mt-1 flex rounded-md shadow-sm"></div>

          <div class="flex flex-wrap -mx-3">
            <div class="mt-6 sm:mt-0 w-full sm:w-2/5 px-2  pt-2">
              <label for="street" class="block text-sm font-medium text-gray-500">street</label>
              <div class="mt-1">
                <input type="text" v-model="dane.street" name="street" id="street" autocomplete="street"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700" />
              </div>
            </div>
            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-2  pt-2">
              <label for="postcode" class="block text-sm font-medium text-gray-500">postcode</label>
              <div class="mt-1">
                <input type="text" v-model="dane.postcode" name="postcode" id="postcode" autocomplete="postcode"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700" />
              </div>
            </div>
            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-2  pt-2">
              <label for="city" class="block text-sm font-medium text-gray-500">city</label>
              <div class="mt-1">
                <input type="text" v-model="dane.city" name="city" id="city" autocomplete="city"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700" />
              </div>
            </div>
          </div>

          <div class="flex flex-wrap -mx-3">
            <div class="mt-6 sm:mt-0 w-full sm:w-2/5 px-2 pt-2">
              <label for="lat" class="block text-sm font-medium text-gray-500">position</label>
              <div class="mt-1">
                <div class="mt-1 relative">
                  <input type="text" name="position" v-model="position" id="position" autocomplete="position"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700 pr-16" />
                  <span @click="position = placeDetails.position" v-if="placeDetails?.position &&
                    position !== placeDetails.position
                    "
                    class="bg-orange-500 hover:bg-orange-600 text-sm text-black px-2 py-1 cursor-pointer rounded-md absolute right-2 top-1/2 transform -translate-y-1/2">update</span>
                </div>
              </div>
            </div>

            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-2  pt-2">
              <label for="lat" class="block text-sm font-medium text-gray-500">gid</label>
              <div class="mt-1">
                <input type="text" v-model="dane.gid" name="gid" id="gid" autocomplete="gid"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700" />
              </div>
            </div>

            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-2  pt-2">
              <label for="lat" class="block text-sm font-medium text-gray-500">cid</label>
              <div class="mt-1">
                <input type="text" v-model="dane.cid" name="cid" id="cid" autocomplete="gid"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700" />
              </div>
            </div>

            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-2  pt-2">
              <label for="google_place_id" class="block text-sm font-medium text-gray-500">google_place_id</label>
              <div class="mt-1">
                <input type="text" v-model="dane.google_place_id" name="google_place_id" id="google_place_id" autocomplete="off" readonly
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700" />
              </div>
            </div>
          </div>

        

          <div class="w-full flex flex-wrap">
            <div class="mt-6 sm:mt-0 sm:w-3/5">
              <label for="type" class="block text-sm font-medium text-gray-200 mt-2">tagi</label>
              <div class="mt-1 relative">
                <!-- Widoczne tagi -->
                <div class="flex flex-wrap gap-2 mb-2 min-h-[32px] p-2 bg-gray-700 border border-gray-600 rounded-md">
                  <div 
                    v-for="(tag, index) in selectedTags" 
                    :key="index"
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                  >
                    {{ tag }}
                    <button 
                      type="button"
                      @click.prevent="removeTag(index)" 
                      class="ml-1 text-green-600 hover:text-green-800 font-bold"
                    >
                      ×
                    </button>
                  </div>
                </div>
                
                <!-- Input do dodawania tagów -->
                <input 
                  type="text" 
                  v-model="tagInput" 
                  name="tagInput" 
                  id="tagInput" 
                  autocomplete="off"
                  @input="filterTags"
                  @focus="showTagSuggestions = true"
                  @blur="hideTagSuggestions"
                  @paste="handleTagPaste"
                  @keydown.enter.prevent="addTagFromInput"
                  @keydown.tab.prevent="addTagFromInput"
                  placeholder="Wpisz nazwę tagu i naciśnij Enter..."
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700" 
                />
                
                <!-- Tag suggestions dropdown -->
                <div v-if="showTagSuggestions && filteredTags.length > 0" class="absolute z-10 w-full mt-1 bg-gray-700 border border-gray-600 rounded-md shadow-lg max-h-60 overflow-auto">
                  <div 
                    v-for="tag in filteredTags" 
                    :key="tag.id"
                    @click="selectTag(tag.name)"
                    class="px-4 py-2 hover:bg-gray-600 cursor-pointer text-white text-sm"
                  >
                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 mr-2">
                      {{ tag.name }}
                    </span>
                    <span v-if="tag.category" class="text-gray-400 text-xs">{{ tag.category }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-6 sm:mt-0 sm:w-1/5">
              <div class="mt-6 sm:mt-0 w-full px-3">
                <label for="author" class="block text-sm font-medium text-gray-200 mt-2">Author</label>
                <div class="mt-1">
                  <select v-model="dane.author" name="author" id="author" autocomplete="author"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700">
                    <option disabled value="">Wybierz autora</option>
                    <option v-for="influencer in influencers" :key="influencer.id" :value="influencer.name">{{ influencer.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mt-6 sm:mt-0 sm:w-1/5 ">
              <div class="mt-6 sm:mt-0 w-full px-3">
                <label for="status" class="block text-sm font-medium text-gray-200 mt-2">status</label>
                <div class="mt-1">
                    <input type="text" v-model="dane.status" name="status" id="status" autocomplete="status"
                      class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700" />
                </div>
              </div>
            </div>
          </div>




        
          <fieldset class="space-x-5 flex flex-wrap items-start py-5 ">
            <div class="relative flex">
              <div class="flex h-5 items-center">
                <label class="flex items-center cursor-pointer select-none">
                  <span class="relative">
                    <input 
                      id="isMuala" 
                      aria-describedby="isMuala-description" 
                      name="isMuala" 
                      v-model="isMualaComputed"
                      type="checkbox" 
                      class="sr-only peer"
                    />
                    <span class="w-11 h-6 bg-gray-400 rounded-full shadow-inner block peer-checked:bg-blue-600 transition-colors"></span>
                    <span class="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"></span>
                  </span>
                  <span class="ml-3 text-sm font-medium text-gray-200">{{ isMualaComputed ? 'YES' : 'NO' }}</span>
                </label>
              </div>
              <div class="ml-3 text-sm">
                <label for="isMuala" class="font-medium text-gray-200">isMuala</label>
                <span id="isMuala-description" class="text-gray-500"><span class="sr-only">isMuala </span></span>
              </div>
            </div>

            <div class="relative flex">
              <div class="flex h-5 items-center">
                <label class="flex items-center cursor-pointer select-none">
                  <span class="relative">
                    <input 
                      id="isGroup" 
                      aria-describedby="isGroup-description" 
                      name="isGroup" 
                      v-model="isGroupComputed"
                      type="checkbox" 
                      class="sr-only peer"
                    />
                    <span class="w-11 h-6 bg-gray-400 rounded-full shadow-inner block peer-checked:bg-blue-600 transition-colors"></span>
                    <span class="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"></span>
                  </span>
                  <span class="ml-3 text-sm font-medium text-gray-200">{{ isGroupComputed ? 'YES' : 'NO' }}</span>
                </label>
              </div>
              <div class="ml-3 text-sm">
                <label for="isGroup" class="font-medium text-gray-200">isGroup</label>
                <span id="isGroup-description" class="text-gray-500"><span class="sr-only">isGroup </span></span>
              </div>
            </div>

            <div class="relative flex">
              <div class="flex h-5 items-center">
                <label class="flex items-center cursor-pointer select-none">
                  <span class="relative">
                    <input 
                      id="isPremium" 
                      aria-describedby="isPremium-description" 
                      name="isPremium" 
                      v-model="isPremiumComputed"
                      type="checkbox" 
                      class="sr-only peer"
                    />
                    <span class="w-11 h-6 bg-gray-400 rounded-full shadow-inner block peer-checked:bg-blue-600 transition-colors"></span>
                    <span class="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"></span>
                  </span>
                  <span class="ml-3 text-sm font-medium text-gray-200">{{ isPremiumComputed ? 'YES' : 'NO' }}</span>
                </label>
              </div>
              <div class="ml-3 text-sm">
                <label for="isPremium" class="font-medium text-gray-200">isPremium</label>
                <span id="isPremium-description" class="text-gray-500"><span class="sr-only">isPremium </span></span>
              </div>
            </div>
          </fieldset>



        </div>
      </div>
      <div class="pt-5"></div>
    </form>








    

    <div class="z-50 fixed bottom-0 left-0 w-full p-5 bg-gray-800">
      <div class="flex justify-end items-center">
        <!-- <span @click="putSearchToMaps()" class="cursor-pointer px-2 py-1 ml-2 bg-gray-800 border border-gray-700 rounded-md hover:border-white transition-colors duration-300">search</span> -->

    

        <button v-if="placeDetailsFull && placeDetailsFull.url" @click="openUrl(placeDetailsFull.url)" type="button"
            class="rounded-md border mr-3 border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2">
            ► see on maps
        </button>




        <button @click="putSearchToMaps()" type="button"
            class="rounded-md border mr-3 border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2">
            Map Search
        </button>


        <button v-if="dane.gid" @click="getPlaceDetails(dane.gid)" type="button"
            class="rounded-md border mr-3 border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2">
            get details
        </button>
        
        <!-- <iconOnly :tagsIds="tagsIds" @updateNextTag="showNextTag" class="mr-3" /> -->
        <div class="flex justify-end">



          <button @click="goBack" type="button"
            class="rounded-md border border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2">
            Cancel
          </button>
          <button type="submit" @click.prevent="saveAll"
            class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-wrap -mx-3">
    <div class="mt-6 sm:mt-0 w-full sm:w-2/5 px-3">
      <div style="display: none">
        <input id="pac-input" class="controls" type="text" placeholder="Enter a location" />
      </div>
    </div>
  </div>

  <div ref="mapElement" class="map" id="map"></div>
  <div id="infowindow-content">
    <span id="place-name" class="title"></span><br />
    <!-- <strong>Place ID:</strong>  -->
    <span id="place-id"></span><br />
    <span id="place-address"></span>

    <br />
    <span id="place-lat"></span>, <span id="place-lng"></span>
  </div>


  <placeDetailsComponent :placeDetailsFull="placeDetailsFull"></placeDetailsComponent>





</template>

<script setup>
import {
  ref,
  onMounted,
  watchEffect,
  watch,
  computed,
  transformVNodeArgs,
} from "vue";

import { useRoute, useRouter } from "vue-router";
import iconOnly from "../components/iconOnly.vue";
import placeDetailsComponent from "../components/placeDetails.vue";
import { apiFetch } from "../composables/apiClient";

import {
  ArrowUpCircleIcon,
  DocumentDuplicateIcon,
  EyeIcon,
  EyeOffIcon,
  SparklesIcon,
} from "@heroicons/vue/20/solid";

const props = defineProps({
  id: String, // Definiujesz 'id' jako prop o typie String
});

const placeDetails = ref(null);
const placeDetailsFull = ref(null);


const router = useRouter();
const route = useRoute();

// Obliczalna właściwość z getterem i setterem
const isMualaComputed = computed({
  get: () => dane.value.isMuala === true, // Konwertuje true na true
  set: (newValue) => {
    dane.value.isMuala = newValue; // Konwertuje true na true, false na false
  },
});

const isGroupComputed = computed({
  get: () => dane.value.isGroup === true, // Konwertuje true na true
  set: (newValue) => {
    dane.value.isGroup = newValue; // Konwertuje true na true, false na false
  },
});

const isPremiumComputed = computed({
  get: () => dane.value.isPremium === true,
  set: (newValue) => {
    dane.value.isPremium = newValue;
  },
});

const goBack = () => {
  router.back();
};

const dane = ref({
  id: "",
  title: "",
  city: "",
  street: "",
  postcode: "",
  position: {lat: 0, lng: 0 },
  type: "",
  haslandingpage: 0,
  isMuala: false,
  isGroup: false,
  isPremium: false,
  metaDescription: "",
  metaTitle: "",
  gid: "",
  cid: "",
  google_place_id: "",
  status: "",
  url_pyszne: "",
  ratingValue: "",
  reviewCount: "",
  publishedat: "",
  author: "",
});

const article = ref({
  id: "",
  json: "",
  placeId: "",
  type: "location",
  editDate: "",
  city: "",
  videoid: "",
});

const metaDane = ref({
  metaDescription: "N/A",
  metaTitle: "N/A",
  metaKeywords: "N/A",
});

// const computedJsonDataJsonFormat = computed(() => {
//   return `${dane.value.title} - ${dane.value.city} | MUALA`;
// });

const computedJsonPreview = computed(() => {
  // zamien wszystkie wystapienia }, na }, i znak nowej linii
  const newLineText = article.value.json.replace(/},/g, "},\n");
  article.value.json = newLineText;
  return newLineText;
});



watch(
  article,
  (newValue, oldValue) => {
    // const jsonData = JSON.stringify(article.value.json)
    if (article.value && article.value.json) {
      const jsonData = JSON.parse(article.value.json);
      console.log("jsonData", jsonData);

      metaDane.value.metaTitle = `${jsonData.html.title}`;
      metaDane.value.metaDescription = `${jsonData.html.description}`;
    }
  },
  { deep: true }
);




watch(
  placeDetails,
  (newValue, oldValue) => {
    if (placeDetails.value?.place_id) {
      dane.value.gid = placeDetails.value.place_id;
      dane.value.google_place_id = placeDetails.value.place_id;
    }

  },
  { deep: true }
);


const tagsIds = ref([]);

const generatingMetaDesc = ref(false);

const influencers = ref([]);

// Tags
const tags = ref([]);
const filteredTags = ref([]);
const showTagSuggestions = ref(false);
const tagInput = ref('');
const selectedTags = ref([]);

// Watcher dla synchronizacji tagów z danymi
watch(selectedTags, () => {
  dane.value.type = convertTagsToString();
}, { deep: true });

// Watcher dla danych - konwertuj string z tagami do tablicy
watch(() => dane.value.type, (newValue) => {
  if (newValue) {
    selectedTags.value = convertStringToTags(newValue);
  }
}, { immediate: true });

// Pobieranie tagów
const fetchTags = async () => {
  try {
    const response = await apiFetch('/api/tags');
    if (response.ok) {
      const data = await response.json();
      tags.value = data.data;
    } else {
      console.error('Błąd podczas pobierania tagów');
    }
  } catch (error) {
    console.error('Błąd:', error);
  }
};

const fetchInfluencers = async () => {
  try {
    const response = await apiFetch('/api/influencers');
    if (response.ok) {
      const data = await response.json();
      influencers.value = data.data;
    } else {
      console.error('Błąd podczas pobierania influencerów');
    }
  } catch (error) {
    console.error('Błąd:', error);
  }
};

// Filtrowanie tagów
const filterTags = () => {
  const input = tagInput.value.toLowerCase();
  if (!input) {
    filteredTags.value = tags.value.slice(0, 10); // Pokaż pierwsze 10 tagów
    return;
  }
  
  filteredTags.value = tags.value
    .filter(tag => tag.name.toLowerCase().includes(input))
    .slice(0, 10); // Maksymalnie 10 sugestii
};

const normalizeTagName = (value) => String(value ?? '').trim().toLowerCase();

const hasSelectedTag = (tagName) =>
  selectedTags.value.some((tag) => normalizeTagName(tag) === normalizeTagName(tagName));

const findExistingTagName = (tagName) => {
  const normalizedTagName = normalizeTagName(tagName);
  if (!normalizedTagName) return null;

  const existingTag = tags.value.find(
    (tag) => normalizeTagName(tag.name) === normalizedTagName
  );
  return existingTag ? existingTag.name : null;
};

const parseTagsFromInput = (rawInput) =>
  String(rawInput ?? '')
    .split(/[,\n;]+/)
    .map((tag) => tag.trim())
    .filter((tag) => tag);

const addExistingTag = (tagName) => {
  const existingTagName = findExistingTagName(tagName);
  if (!existingTagName || hasSelectedTag(existingTagName)) return false;
  selectedTags.value.push(existingTagName);
  return true;
};

const addTagsFromRawInput = (rawInput) => {
  const parsedTags = parseTagsFromInput(rawInput);
  parsedTags.forEach((tagName) => addExistingTag(tagName));
};

// Wybór tagu
const selectTag = (tagName) => {
  addExistingTag(tagName);
  tagInput.value = ""; // Wyczyść input po wybraniu tagu
  showTagSuggestions.value = false;
};

// Dodaj tag z inputa
const addTagFromInput = () => {
  addTagsFromRawInput(tagInput.value);
  tagInput.value = "";
  showTagSuggestions.value = false;
};

const handleTagPaste = (event) => {
  const pastedText = event?.clipboardData?.getData('text') ?? '';
  if (!/[,\n;]/.test(pastedText)) return;

  event.preventDefault();
  addTagsFromRawInput(pastedText);
  tagInput.value = '';
  showTagSuggestions.value = false;
};

// Usuń tag
const removeTag = (index) => {
  selectedTags.value.splice(index, 1);
};

// Konwertuj tagi do formatu JSON string
const convertTagsToString = () => {
  return JSON.stringify(selectedTags.value);
};

// Konwertuj string z tagami do tablicy
const convertStringToTags = (tagString) => {
  if (!tagString) return [];
  try {
    return JSON.parse(tagString);
  } catch (e) {
    // Fallback dla starego formatu (przecinki)
    return tagString.split(',').map(t => t.trim()).filter(t => t);
  }
};

// Ukryj sugestie tagów
const hideTagSuggestions = () => {
  setTimeout(() => {
    showTagSuggestions.value = false;
  }, 200);
};

const saveTag = async () => {
  try {
    console.log("saveTag dane.value", dane.value);
    console.log(JSON.stringify(dane.value));

    const daneDoWyslania = {
      ...dane.value,
      isMuala: dane.value.isMuala ? true : false,
      haslandingpage: article.value.json ? 1 : 0,
      isGroup: dane.value.isGroup ? true : false,
      isPremium: dane.value.isPremium ? true : false,
      type: convertTagsToString(), // Zapisz tagi jako string
    };

    // console.log("dane.value", dane.value);

    console.log("daneDoWyslania:", daneDoWyslania);

    const response = await apiFetch(
      `/api/dane/${route.params.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(daneDoWyslania),
      }
    );
    if (response.ok) {
      console.log("SAVED!");
      //   router.push('/');
    } else {
      throw new Error("Problem z zapisem danych");
    }
  } catch (error) {
    console.error(error);
  }
};

// const saveArticle = async () => {
//   try {
//     // console.log(dane.value);
//     console.log(JSON.stringify(article.value));

//     const rawJson = JSON.parse(article.value.json);
//     rawJson.html.title = metaDane.value.metaTitle;
//     rawJson.html.description = metaDane.value.metaDescription;
//     const rawJsonString = JSON.stringify(rawJson);

//     // console.log("rawJson:", rawJson);
//     // console.log("rawJsonString:", rawJsonString);

//     article.value.json = rawJsonString;
//     article.value.id = route.params.id;
//     article.value.placeId = route.params.id;
//     article.value.type = "location";
//     article.value.city = dane.value.city;
//     article.value.videoId = dane.value.videoId;

//     // articleFromDb.json = JSON.parse(articleFromDb.json);
//     // w druga strone odczytanie z bazy

//     const daneDoWyslania = {
//       ...article.value,
//     };

//     // console.log("dane.value", dane.value);

//     console.log("daneDoWyslania Article", daneDoWyslania);

//     const response = await fetch(
//       `http://localhost:3007/article`, ///${route.params.id}
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(daneDoWyslania),
//       }
//     );
//     if (response.ok) {
//       console.log("SAVED ARTICLE!");
//       //   router.push('/');
//     } else {
//       throw new Error("Problem z zapisem danych");
//     }
//   } catch (error) {
//     console.error(error);
//   }
// };

const saveAll = async () => {
  try {
    // await saveTag();
    await addNewPlace(dane.value);
    // await saveArticle();
  } catch (error) {
    console.error(error);
  }
};

const showNextTag = (tagId) => {
  router.push({ name: "tag", params: { id: tagId } });
  placeDetails.value = null;
  placeDetailsFull.value = null;
};

const fetchAllData = async () => {
  try {
    const response = await apiFetch("/api/dane");
    if (response.ok) {
      const data = await response.json();
      dane.value = data.data;
      // groups.value = Array.from(new Set(data.data.map(item => item.tagGroup))).sort();
      // langs.value = Array.from(new Set(data.data.map(item => item.lang))).sort();
      tagsIds.value = data.data.map((object) => object.id);
      //   console.log(tagsIds.value);
    } else {
      throw new Error("Problem z pobraniem danych");
    }
  } catch (error) {
    console.error(error);
  }
};

const fetchSpecificData = async (id) => {
  try {
    const response = await apiFetch(`/api/dane/${id}`);
    if (response.ok) {
      const data = await response.json();
      console.log("fetchSpecificData:", data.data);
      dane.value = data.data;
      console.log(dane.value);
    } else {
      throw new Error("Problem z pobraniem danych");
    }
  } catch (error) {
    console.error(error);
  }
};

const fetchArticleData = async (id) => {
  try {
    const response = await apiFetch(`/api/article/${id}`);
    if (response.ok) {
      const data = await response.json();
      article.value = data.data;
      // console.log(dane.value);
    } else {
      throw new Error("Problem z pobraniem danych");
    }
  } catch (error) {
    console.error(error);
  }
};

// Obliczalna właściwość z getterem i setterem
const position = computed({
  // Getter tworzy string z lat i lng
  get: () => `${dane.value.lat}, ${dane.value.lng}`,
  // Setter aktualizuje lat i lng na podstawie zmienionej wartości position
  set: (newValue) => {
    const [lat, lng] = newValue.split(",").map(Number);
    dane.value.lat = lat;
    dane.value.lng = lng;
  },
});

onMounted(async () => {
  const id = route.params.id; // Pobiera ID z URL
  // console.log(id);

  try {
    // await fetchAllData();
    // await fetchSpecificData(id);
    // await fetchArticleData(id);
    await fetchTags(); // Wywołaj funkcję pobierania tagów
    await fetchInfluencers();
  } catch (error) {
    console.error(error);
  }
});

watch(
  () => route.params.id,
  (newId) => {
    if (newId) {
      article.value.json = "";
      fetchSpecificData(newId);
      fetchArticleData(newId);
    }
  },
  { immediate: true }
);

function removeQuotes(tekst) {
  if (tekst.startsWith('"') && tekst.endsWith('"')) {
    return tekst.slice(1, -1);
  }
  return tekst;
}

async function copyToClipboard(wartosc) {
  try {
    await navigator.clipboard.writeText(wartosc);
    console.log("Tekst skopiowany do schowka");
  } catch (err) {
    console.error("Błąd podczas kopiowania do schowka: ", err);
  }
}

function changeToUrlTypeString(str) {
  return str.toLowerCase().replace(/\s+/g, "-");
}

let exceptions = ["to", "for", "with"];

function titleCase(str, exceptions) {
  return str
    .split(" ")
    .map((word, index) => {
      if (index === 0 || !exceptions.includes(word.toLowerCase())) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word.toLowerCase();
    })
    .join(" ");
}

function countCharactersWithEmojis(text = "") {
  // if (typeof input === 'undefined' || input === null) {
  //   // Obsługa przypadku, gdy input jest undefined lub null
  //   return 0; // lub inna odpowiednia wartość domyślna
  // }

  const splitText = Array.from(text);
  return splitText.length;
}


const putSearchToMaps = () => {
  const input = document.getElementById("pac-input");
  if (input) {
    input.value = `${dane.value.title} ${dane.value.street}` ;
    input.focus();
  }
}



const map = ref(null);
const mapElement = ref(null);
const infowindowRef = ref(null);
const initialPosition = { lat: 52.22977, lng: 21.01178 };

onMounted(() => {
  loadGoogleMapsScript().then(() => {
    initMap();
  });
});

function initMap() {
  map.value = new google.maps.Map(document.getElementById("map"), {
    center: { lat: initialPosition.lat, lng: initialPosition.lng },
    zoom: 13,
  });
  const input = document.getElementById("pac-input");
  // Specify just the place data fields that you need.
  const autocomplete = new google.maps.places.Autocomplete(input, {
    fields: ["place_id", "geometry", "formatted_address", "name"],
  });

  autocomplete.bindTo("bounds", map.value);
  map.value.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

  const infowindow = new google.maps.InfoWindow();
  infowindowRef.value = infowindow;
  // console.log("infowindowRef.value: ", infowindowRef.value);

  const infowindowContent = document.getElementById("infowindow-content");
  infowindow.setContent(infowindowContent);

  const marker = new google.maps.Marker({ map: map.value });

  marker.addListener("click", () => {
    infowindow.open(map.value, marker);
  });
  autocomplete.addListener("place_changed", () => {
    infowindow.close();

    const place = autocomplete.getPlace();

    if (!place.geometry || !place.geometry.location) {
      return;
    }

    if (place.geometry.viewport) {
      map.value.fitBounds(place.geometry.viewport);
    } else {
      map.value.setCenter(place.geometry.location);
      map.value.setZoom(14);
    }

    // Set the position of the marker using the place ID and location.
    // @ts-ignore This should be in @typings/googlemaps.
    marker.setPlace({
      placeId: place.place_id,
      location: place.geometry.location,
    });
    marker.setVisible(true);
    infowindowContent.children.namedItem("place-name").textContent = place.name;
    infowindowContent.children.namedItem("place-id").textContent =
      place.place_id;
    infowindowContent.children.namedItem("place-address").textContent =
      place.formatted_address;
    infowindowContent.children.namedItem("place-lat").textContent =
      place.geometry.location.lat();
    infowindowContent.children.namedItem("place-lng").textContent =
      place.geometry.location.lng();

    infowindow.open(map.value, marker);

    console.log("place: ", place);
    placeDetails.value = place;
    placeDetails.value.position = `${place.geometry.location.lat()}, ${place.geometry.location.lng()}`;
    // placeDetails.value.position = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };

  });
}

function loadGoogleMapsScript() {
  return new Promise((resolve) => {
    if (typeof google !== "undefined" && google.maps) {
      resolve();
    } else {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCiNeI2j5GhrMCeyJcEtCmPxJdejQXr7r0&callback=initMap`;
      script.async = true;
      document.head.appendChild(script);
      window.initMap = () => {
        resolve();
      };
    }
  });
}

function getPlaceDetails(placeId) {
  const request = {
    placeId: placeId,
    fields: [
      "name",
      "rating",
      "formatted_phone_number",
      "geometry",
      "business_status",
      "address_components",
      "formatted_address",
      "formatted_phone_number",
      "plus_code",
      "icon",
      "opening_hours",
      "photos",
      "place_id",
      "reviews",
      "types",
      "url",
      "vicinity",
      "website",
      "price_level",
      "international_phone_number",
      "adr_address",
      "scope",
      "user_ratings_total",
      "utc_offset_minutes",
      "url",
      "serves_beer",
      "serves_breakfast",
      "serves_brunch",
      "serves_dinner",
      "serves_lunch",
      "serves_vegetarian_food",
      "serves_wine",
      "takeout",
      "editorial_summary",
      "dine_in",
      "delivery",
    ],
  };

  const service = new google.maps.places.PlacesService(map.value);
  service.getDetails(request, function (place, status) {
    if (status === google.maps.places.PlacesServiceStatus.OK) {
      // console.log("Place details:", place);
      placeDetailsFull.value = place;
      console.log("placeDetailsFull.value: ", placeDetailsFull.value);
      // createMarker(place); // Załóżmy, że createMarker jest już zdefiniowaną funkcją.
    } else {
      console.error("Place details request failed due to ", status);
    }
  });
}


watch(placeDetailsFull, (newVal) => {
  console.log("Nowa wartość placeDetailsFull w Tag.vue:", newVal);
});


const openUrl = (url) => {
  window.open(url, '_blank');
};




// const splitFormattedAdress = (formattedAdress) => {
//     const arrayAdress = formattedAdress.split(" ")
//     console.log("arrayAdress:", arrayAdress)
//     let city = arrayAdress.pop();
//     let postCode = arrayAdress.pop();
//     let street = arrayAdress.join(" ").replace(",", "")
  
//     const fullAdress = {
//         street: street,
//         postcode: postCode,
//         city: city
//         }
  
//         return fullAdress
//   }

  const splitFormattedAdress = (formattedAdress) => {
    // Najpierw dzielimy string po przecinkach
    const mainParts = formattedAdress.split(",").map(part => part.trim());
    
    // Pierwsza część to ulica
    const street = mainParts[0];
    
    // Druga część zawiera kod pocztowy i miasto
    const postCodeAndCity = mainParts[1].split(" ");
    const postCode = postCodeAndCity[0];
    const city = postCodeAndCity[1];
  
    const fullAdress = {
        street: street,
        postcode: postCode,
        city: city
    }
  
    return fullAdress;
}


watch(
  placeDetailsFull,
  (newValue, oldValue) => {
    if (placeDetailsFull.value?.url) {
      dane.value.cid = placeDetailsFull.value.url.split("=")[1];
    }

  },
  { deep: true }
);

watch(
  placeDetails,
  (newValue, oldValue) => {
    if (placeDetails.value?.name && dane.value.title === "") {

      console.log("X placeDetails.value:", placeDetails.value);
      dane.value.title = placeDetails.value.name;

      const fullAdress = splitFormattedAdress(placeDetails.value.formatted_address);
      console.log("splitFormattedAdress fullAdress:", fullAdress);
      
      dane.value.street = fullAdress.street;
      dane.value.postcode = fullAdress.postcode;
      dane.value.city = fullAdress.city;
      dane.value.position = placeDetails.value.position 

      position.value = placeDetails.value.position

    }
   
    console.log("X dane.value:", dane.value);

  },
  { deep: true }
);






const addNewPlace = async (originalData) => {
    try {
      console.log("originalData:", originalData);

      // Sprawdź czy wymagane pola są wypełnione
      if (!originalData.title || !originalData.city) {
        throw new Error('Tytuł i miasto są wymagane');
      }

      const preparedData = {
        title: originalData.title,
        street: originalData.street || '',
        postcode: originalData.postcode || '',
        city: originalData.city,
        lat: originalData.position?.lat || originalData.lat || 0, 
        lng: originalData.position?.lng || originalData.lng || 0,
        type: originalData.type || '',
        gid: originalData.gid || '',
        cid: originalData.cid || '',
        google_place_id: originalData.google_place_id || '',
        haslandingpage: false, // Dostosowane do rzeczywistej struktury bazy
        publishedat: originalData.publishedat || new Date().toISOString().split('T')[0], // Domyślna data dzisiejsza
        isMuala: originalData.isMuala || false,
        isGroup: originalData.isGroup || false,
        isPremium: originalData.isPremium || false,
        status: originalData.status || '',
        author: JSON.stringify(originalData.author ? [originalData.author] : []),
        adddate: new Date().toISOString(), // Dodajemy aktualną datę (małe litery)
        editdate: new Date().toISOString() // Dostosowane do rzeczywistej struktury bazy
      };

      // Usuń pole id jeśli istnieje (nie wysyłamy ID dla nowego rekordu)
      if (preparedData.hasOwnProperty('id')) {
        delete preparedData.id;
        console.log("Removed id field from preparedData");
      }
      
      console.log("Final preparedData keys:", Object.keys(preparedData));
      console.log("preparedData:", preparedData);
      console.log("JSON string:", JSON.stringify(preparedData));
  
      const response = await apiFetch('/api/dane', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(preparedData),
      });
  
      console.log("Response status:", response.status);
      console.log("Response ok:", response.ok);
  
      if (response.ok) {
        const responseData = await response.json();
        console.log("SAVED! Response:", responseData);
        
        // Pokaż komunikat o sukcesie
        const successMessage = document.createElement('div');
        successMessage.className = 'fixed top-4 right-4 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50';
        successMessage.textContent = 'Lokal został pomyślnie zapisany!';
        document.body.appendChild(successMessage);
        
        setTimeout(() => {
          document.body.removeChild(successMessage);
          // Przekieruj do listy lokali
          router.push('/');
        }, 2000);
        
      } else {
        const errorText = await response.text();
        console.error("Server error response:", errorText);
        throw new Error(`Problem z zapisem danych: ${response.status} - ${errorText}`);
      }
    } catch (error) {
      console.error("Error in addNewPlace:", error);
      
      // Pokaż komunikat o błędzie
      const errorMessage = document.createElement('div');
      errorMessage.className = 'fixed top-4 right-4 bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg z-50';
      errorMessage.textContent = `Błąd: ${error.message}`;
      document.body.appendChild(errorMessage);
      
      setTimeout(() => {
        document.body.removeChild(errorMessage);
      }, 3000);
    }
  };


</script>

<style>
#googleUrl {
  display: inline-block;
  cursor: pointer;
  font-weight: normal;
  font-size: small;
  line-height: 1.58;
  font-family: Roboto, arial, sans-serif;
  font-size: 14px;
  line-height: 1.3;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  color: #a8a8a8;
  font-style: normal;
}

#googleBreakcrumbs {
  display: inline-block;
  cursor: pointer;
  font-weight: normal;
  font-family: Roboto, arial, sans-serif;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  color: #a8a8a8;
  font-style: normal;
  font-size: 12px;
  line-height: 18px;
  margin-top: -5px;
}

#googleTitle {
  padding-top: 5px;
  margin-bottom: 3px;
  font-size: 20px;
  line-height: 1.3;
  /* color: #1a0dab; */
  color: #8ab4f8;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

#googleTitle2 {
  margin-left: -14px;
  width: 625px;
  padding-top: 5px;
  margin-bottom: 3px;
  font-size: 20px;
  line-height: 1.3;
  /* color: #1a0dab; */
  color: #8ab4f8;

  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

#googleDescription {
  max-width: 48em;
  color: #4d5156;
  line-height: 1.58;
  font-family: Roboto, arial, sans-serif;
  font-size: 14px;
}

#googleDescription2 {
  width: 626px;
  height: 88px;
  /* color: #4d5156; */
  color: #c9c9c9;

  line-height: 1.58;
  font-family: Roboto, arial, sans-serif;
  font-size: 14px;
  margin-left: -13px;
}

.whiteGoogle {
  /* background-color: #fff; */
  padding: 25px;
  width: 650px;
  margin: auto;
}

.dots {
  height: 18px;
  line-height: 18px;
  width: 18px;
  opacity: 0.6;
  padding-top: 4px;
  margin-left: 12px;
}

#googleBox span {
  display: inline-block;
}

.googleTop {
  display: flex;
  align-items: center;
  /* Wycentrowanie elementów w pionie */
  padding-bottom: 10px;
}

.favicon {
  display: flex;
  justify-content: center;
  /* Wyśrodkowanie w poziomie */
  align-items: center;
  /* Wyśrodkowanie w pionie */
  background-color: #f1f3f4;
  border: 1px solid #ecedef;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  margin-right: 12px;
}

.favicon>div {
  display: flex;
  justify-content: center;
  /* Wyśrodkowanie w poziomie */
  align-items: center;
  /* Wyśrodkowanie w pionie */
  height: 100%;
  /* Pełna wysokość kontenera .favicon */
  width: 100%;
  /* Pełna szerokość kontenera .favicon */
}

.favicon img {
  max-width: 18px;
  height: 18px;
  /* Wysokość obrazka */
  width: 18px;
  /* Szerokość obrazka */
}

.smallText {
  display: block;
  /* Pozwól, aby elementy w .smallText były ułożone pionowo */
}

.smallText>div {
  display: block;
  /* Ustawia elementy w .smallText jeden pod drugim */
}

.googleBreadcrumbsContainer {
  margin-top: -10px;
}


#place-name {
  font-weight: bold;
}
#place-address {
  margin-bottom: 10px;
}

.dot {
  transition: transform 0.2s;
}
input[type="checkbox"].peer:checked + span + .dot {
  transform: translateX(20px);
}
</style>
